
<ng-container>
  <div *ngIf="cancellationPolicies?.from !== 'N/A'; else noData" class="timeline-container">


    <!-- Línea de tiempo horizontal -->
    <div class="timeline-wrapper">
      <div class="timeline-track">


          <div class="timeline-segment flex-column" [style.width.%]="getSegmentWidth(0)">
            <div class="d-flex flex-column align-items-center" style="width: 100%">
                <img src="../../../../assets/icons/search-result/gratuita.svg" style="width: 26px" alt="">
                  <p style="font-family: 'Poppins', sans-serif;font-size: 18px;font-weight:500;color:black;padding-bottom: 25px;margin-top: 15px">Cancelación gratuita</p>
            </div>

            <div class=" timeline-segment free-segment" style="height: 12px;border-bottom-left-radius: 6px;border-top-left-radius: 6px; width: 100%">

            </div>

            <div class="d-flex justify-content-end pr-2" style="width: 100%;">
              <!-- <div class="d-flex flex-column">
                <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black;margin-top:20px">Desde el</p>
              </div> -->
              <div class="d-flex flex-column">
                <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black;margin-top:20px">Hasta el </p>
                <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black">{{ adjustDate(cancellationPolicies.from, -1) | date : 'dd/MM/yyyy' }}</p>
              </div>
            </div>

            <p style="font-family: 'Poppins', sans-serif;font-size: 14px;font-weight:500;color:#2e7d32;margin-top:10px">Reembolso total</p>
          </div>

          <div
          *ngFor="let policy of cancellationPolicies?.cancellationPolicies; let i = index"
          class="timeline-segment flex-column"
          style="position:relative"
          [style.width.%]="getSegmentWidth(i + 1)"
        >
          <div class="d-flex flex-column align-items-center" style="width: 100%">
                <img src="../../../../assets/icons/search-result/parcial.svg" style="width: 26px" alt="">
                   <p style="font-family: 'Poppins', sans-serif;font-size: 18px;font-weight:500;color:black;padding-bottom: 25px;margin-top: 15px">Reembolso parcial</p>
          </div>

           <!-- <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 20px;font-weight:600;color:black;margin-top: -14px;padding-bottom: 45px">({{ currencyAgency?.code }} {{ policy?.amount | number : '1.2-2' }})</p> -->

            <div style="position:absolute;left: 0;top:45%;z-index:9999;height: 30px; background-color: black; width: 1px">

            </div>

             <div class="timeline-segment partial-segment" style="height: 12px; width: 100%;">

            </div>

            <div style="position:absolute;right: 0;top:45%;z-index:9999;height: 30px; background-color: black; width: 1px">

            </div>


          <div class="d-flex justify-content-between px-2" style="width: 100%;">
             <div class="d-flex flex-column">
              <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black;margin-top:20px">Del</p>
              <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black">{{ policy.from | date : 'dd/MM/yyyy' }}</p>
             </div>
           <div class="d-flex flex-column">
              <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black;margin-top:20px">Hasta</p>
              <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black">{{ getNextDate(i) | date : 'dd/MM/yyyy' }}</p>
           </div>

          </div>

          <p style="width: 100%;text-align:center;font-family: 'Poppins', sans-serif;font-size: 14px;font-weight:500;color:#ffb300;border-left: 1.5px solid black; border-right: 1.5px solid black;margin-top:10px">Reembolso parcial</p>

      </div>

      <div class="timeline-segment flex-column" [style.width.%]="getSegmentWidth(cancellationPolicies?.cancellationPolicies?.length + 1)">

        <div class="d-flex flex-column align-items-center" style="width: 100%">
                <img src="../../../../assets/icons/search-result/sin_reembolso.svg" style="width: 26px" alt="">
          <p  style="font-family: 'Poppins', sans-serif;font-size: 18px;font-weight:500;color:black;padding-bottom: 25px;margin-top: 15px">Sin reembolso</p>
        </div>

            <div class=" timeline-segment no-refund-segment" style="height: 12px;border-bottom-right-radius: 6px;border-top-right-radius: 6px; width: 100%">

            </div>

          <div class="d-flex justify-content-start  pl-2" style="width: 100%;">
           <div class="d-flex flex-column">
             <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black;margin-top:20px">Desde el</p>
             <p class="mb-0" style="font-family: 'Poppins', sans-serif;font-size: 12px;font-weight:500;color:black">{{ cancellationPolicies.arrivalDate | date : 'dd/MM/yyyy' }}</p>
           </div>

          </div>

                    <p style="font-family: 'Poppins', sans-serif;font-size: 14px;font-weight:500;color:#d32f2f;margin-top:10px">Pérdida total</p>
          </div>

      </div>
    </div>

    <!-- Indicador HOY -->
    <div class="today-indicator" [style.left.%]="getTodayPosition()">
      <div class="d-flex flex-column p-1 align-items-center" style="background-color: black; border-radius: 6px;">
        <div class="today-label">HOY</div>
        <div class="today-date">{{ today | date : 'dd/MM/yyyy' }}</div>
      </div>
      <div class="today-dot"></div>

    </div>

  </div>

  <ng-template #noData>
    <p class="date mb-0">N/A</p>
  </ng-template>
</ng-container>

<ng-container>
    <div class="d-flex flex-column" *ngIf="cancellationPolicies.from !== 'N/A'">
    <div class="d-flex align items-start py-4" style="border-bottom: .5px solid #b3b3b3;">
      <div class="d-flex flex-column" style="width: 40%;gap: .5em">
          <p class="mb-0 text-generic" >
          Hasta el
          </p>
          <p class="mb-0 date">
          {{adjustDate(cancellationPolicies.from, -1) | date : "dd/MM/yyyy" }}
          </p>
      </div>
      <div class="d-flex flex-column" style="width: 60%;gap: .5em">
        <p class="mb-0 "  style="font-family: 'Poppins', sans-serif;font-size: 18px !important;font-weight: 500;line-height: 1">
          Cancelación gratuita
          </p>
          <p class="mb-0 text-generic">
            Podras cancelar sin cargo
          </p>
      </div>
    </div>
    <div class="d-flex align items-start py-4" style="border-bottom: .5px solid #b3b3b3;gap: .5em">
       <div class="d-flex flex-column" style="width: 100%">
            <!-- <div style="height: 18px;margin-bottom: 8px"></div> -->
           <div class="d-flex align-items-start" style="width: 100%">
              <div style="width: 40%"></div>
              <div style="width: 60%">
                <p  style="margin-bottom: 8px;font-family: 'Poppins', sans-serif;font-size: 18px !important;font-weight: 500;line-height: 1; width: 60%">
                  Cancelación con Penalidad Parcial
                </p>
              </div>
            </div>
            <div class="d-flex flex-column" style="width: 100%">
              <ng-container *ngFor="let cancellation_policy of cancellationPolicies?.cancellationPolicies;let i = index">
                <ng-container *ngIf="cancellation_policy.amount > 0">
                  <div class="d-flex align-items-start" style="width: 100%; margin-bottom: 4em">
                    <div style="width: 40%;" >

                      <p class="text-generic" style="margin-bottom: .5em">Hasta el</p>
                      <p class="date" [ngStyle]="{'margin-bottom': cancellation_policy?.fromTimeZoneAgency && cancellation_policy?.fromTime ? '1rem' : '0'}">
                        {{ cancellationPolicies?.cancellationPolicies.length > 1 && cancellationPolicies?.cancellationPolicies[i + 1] ? (cancellationPolicies?.cancellationPolicies[i + 1]?.from | date : "dd/MM/yyyy") : (adjustDate(cancellationPolicies.arrivalDate, -1) | date : "dd/MM/yyyy") }}
                      </p>

                      <ng-container *ngIf="cancellation_policy?.fromTimeZoneAgency && cancellation_policy?.fromTime">
                        <p class="mb-0 text-generic" style="margin-bottom: .25em">Hora de la agencia</p>
                        <p class="mb-2 text-generic">
                          <span style="font-weight: 600">{{splitHour(cancellation_policy.fromTimeZoneAgency)}}</span> {{splitText(cancellation_policy.fromTimeZoneAgency)}}
                        </p>

                        <p class="mb-0 text-generic"  style="margin-bottom: .25em">Hora del proveedor</p>
                        <p class="mb-0 text-generic">
                          <span style="font-weight: 600">{{splitHour(cancellation_policy.fromTime)}}</span> {{splitText(cancellation_policy.fromTime)}}
                        </p>
                      </ng-container>


                    </div>

                    <div style="width: 60%">
                      <p class="mb-0 text-generic" style="height: 18px;margin-top:20px;">
                            <ng-container *ngIf="cancellation_policy?.amountProf">
                              Se aplicara una penalidad de <span style="font-size: 14px !important;font-weight: 600;">{{currencyAgency?.code}}
                                                          {{cancellation_policy?.amountProf
                                                              | currencyConverterPure:
                                                                cancellationPolicies?.currencyCancellation:
                                                                currencyAgency.code:
                                                                currencies
                                                              | number: '1.2-2'}} </span> del total de la reserva
                            </ng-container>
                            <ng-container *ngIf="!cancellation_policy?.amountProf"
                            >
                            Se aplicara una penalidad de <span style="font-size: 14px !important;font-weight: 600;">{{currencyAgency?.code}}
                                                        {{cancellation_policy?.amount
                                                            | currencyConverterPure:
                                                              cancellationPolicies?.currencyCancellation:
                                                              currencyAgency.code:
                                                              currencies
                                                            | number: '1.2-2'}}</span> del total de la reserva
                          </ng-container>

                        </p>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>

    </div>
    <div class="d-flex align items-start py-4" >
      <div class="d-flex flex-column" style="width: 40%;gap: .5em">
          <p class="mb-0 text-generic">
          A partir del
          </p>
            <p class="mb-0 date">
          {{cancellationPolicies.arrivalDate | date : "dd/MM/yyyy" }}
          </p>
      </div>
      <div class="d-flex flex-column" style="width: 60%;gap: .5em">
        <p class="mb-0 "  style="font-family: 'Poppins', sans-serif;font-size: 18px !important;font-weight: 500;line-height: 1">
          Sin Reembolso
          </p>
          <p class="mb-0 text-generic">
            No se aceptarán cancelaciones ni reembolsos; también aplica en casos de no presentación.
          </p>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column" *ngIf="cancellationPolicies.from === 'N/A'">
    <p class="date mb-0">N/A</p>
  </div>
</ng-container>


<!-- <ng-container *ngIf="cancellationPolicies.rateClass === 'NR'">
  <p class="date mb-0">100% costo</p>
</ng-container> -->
